import * as React from 'react';

import { Button } from '@rematter/ui-web';

import { useTranslations } from '~/shared/i18n/useTranslations';

type CheckEmailMessageProps = {
  email: string;
};

export const CheckEmailMessage = ({ email }: CheckEmailMessageProps) => {
  const t = useTranslations();

  return (
    <div className="@CheckEmailMessage flex flex-col items-center gap-6 text-center">
      <div className="rounded-full bg-primary/10 p-6">
        <svg
          className="h-12 w-12 text-primary"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </div>

      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          {t.auth.checkEmail.title}
        </h1>
        <p className="mt-2 text-sm text-neutral">
          {t.auth.checkEmail.sentVerificationLink}
        </p>
        <p className="mt-1 text-sm font-medium text-foreground">{email}</p>
      </div>

      <div className="w-full rounded-lg bg-foreground/5 p-4">
        <p className="text-sm text-neutral">{t.auth.checkEmail.linkExpiry}</p>
      </div>

      <div className="flex w-full flex-col gap-3">
        <div className="text-center text-sm text-neutral">
          {t.auth.checkEmail.didntReceive}{' '}
          <button
            type="button"
            className="font-medium text-primary-darker hover:text-primary/80"
            onClick={() => window.location.reload()}
          >
            {t.auth.checkEmail.tryAgain}
          </button>
        </div>

        <Button
          variant="outline"
          color="neutral"
          onPress={() => (window.location.href = '/sign-in')}
        >
          {t.auth.checkEmail.backToSignIn}
        </Button>
      </div>
    </div>
  );
};
